import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/stage-checkmark-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-531c4011"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-identification-legal" }
const _hoisted_2 = {
  key: 1,
  class: "wizard"
}
const _hoisted_3 = { class: "identification_box" }
const _hoisted_4 = { class: "identification_list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_beginning_work = _resolveComponent("beginning-work")!
  const _component_company_tab = _resolveComponent("company-tab")!
  const _component_beneficiary_tab = _resolveComponent("beneficiary-tab")!
  const _component_director_tab = _resolveComponent("director-tab")!
  const _component_business_profile_tab = _resolveComponent("business-profile-tab")!
  const _component_liveness_tab = _resolveComponent("liveness-tab")!
  const _component_ui_message_error = _resolveComponent("ui-message-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.Step === 1)
      ? (_openBlock(), _createBlock(_component_beginning_work, {
          key: 0,
          onNext: _ctx.GoNext
        }, null, 8, ["onNext"]))
      : _createCommentVNode("", true),
    (_ctx.Step != 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("Identification")), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["item", _ctx.getStyles({ step: 2 })])
              }, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setStep(2)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Company")) + " ", 1),
                  _hoisted_5
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["item", _ctx.getStyles({ step: 3 })])
              }, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStep(3)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Beneficiary")) + " ", 1),
                  _hoisted_6
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["item", _ctx.getStyles({ step: 4 })])
              }, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStep(4)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Header.Director")) + " ", 1),
                  _hoisted_7
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["item", _ctx.getStyles({ step: 5 })])
              }, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStep(5)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Header.BusinessProfile")) + " ", 1),
                  _hoisted_8
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["item", _ctx.getStyles({ step: 6 })])
              }, [
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setStep(6)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Liveness")) + " ", 1),
                  _hoisted_9
                ])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.Step == 2)
      ? (_openBlock(), _createBlock(_component_company_tab, {
          key: 2,
          onCheck: _ctx.updateCheckNew
        }, null, 8, ["onCheck"]))
      : _createCommentVNode("", true),
    (_ctx.Step == 3)
      ? (_openBlock(), _createBlock(_component_beneficiary_tab, {
          key: 3,
          onChangeTab: _ctx.changeTab,
          onCheck: _ctx.updateCheckNew
        }, null, 8, ["onChangeTab", "onCheck"]))
      : _createCommentVNode("", true),
    (_ctx.Step == 4)
      ? (_openBlock(), _createBlock(_component_director_tab, {
          key: 4,
          onCheck: _ctx.updateCheckNew,
          onChangeTab: _ctx.changeTab
        }, null, 8, ["onCheck", "onChangeTab"]))
      : _createCommentVNode("", true),
    (_ctx.Step == 5)
      ? (_openBlock(), _createBlock(_component_business_profile_tab, {
          key: 5,
          onCheck: _ctx.updateCheckNew,
          onChangeTab: _ctx.changeTab
        }, null, 8, ["onCheck", "onChangeTab"]))
      : _createCommentVNode("", true),
    (_ctx.Step == 6)
      ? (_openBlock(), _createBlock(_component_liveness_tab, {
          key: 6,
          onCheck: _ctx.updateCheckNew,
          onEnd: _ctx.goTofinish
        }, null, 8, ["onCheck", "onEnd"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_message_error, { errorMessage: _ctx.errorMessage }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["errorMessage"])
  ]))
}